import getUserFromStorage from './get-user-from-storage'

const getAccessToken = () => getUserFromStorage()?.access_token

export default getAccessToken
